module.exports = __webpack_public_path__ + "img/government-programme-value3.7172b59a.png";